import React, { useState } from 'react';
import {
  GetAppTranslationsDocument,
  useGetAppTranslationsQuery,
} from '../../graphql/queries/getAppTranslations.generated';
import {
  AppTranslationAppType,
  AppTranslationEntry,
} from '../../graphql/generatedTypes';
import Checkbox from '../../components/Checkbox';
import {
  CheckBoxLabel,
  CheckBoxLabelContainer,
} from '../../components/Checkbox/pickpackCheckbox';
import { CreateAppTranslation } from './CreateAppTranslation';
import { useRemoveAppTranslationMutation } from '../../graphql/mutations/removeAppTranslation.generated';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { Button, Table } from 'reactstrap';
import { EditAppTranslationForm } from './EditAppTranslationForm';
import { ContentSection } from '../../components/Layout/ContentSection';

export function AppTranslationsPage() {
  const [appType, setAppType] = React.useState<AppTranslationAppType>(
    AppTranslationAppType.ConsumerApp,
  );
  const { data, loading } = useGetAppTranslationsQuery({
    variables: { app_type: appType },
  });
  const [removeAppTranslation, { loading: removingAppTranslation }] =
    useRemoveAppTranslationMutation();
  const [expandedTranslationIds, setExpandedTranslationIds] = useState<
    Record<string, boolean>
  >({});

  async function onRemoveAppTranslationClick(translation: AppTranslationEntry) {
    if (!confirm('Are you sure you want to delete this translation?')) {
      return;
    }
    await removeAppTranslation({
      variables: {
        id: translation.id,
      },
      refetchQueries: [
        {
          query: GetAppTranslationsDocument,
          variables: {
            app_type: appType,
          },
        },
      ],
    });
  }

  function toggleExpandTranslationId(translationId: string) {
    setExpandedTranslationIds({
      ...expandedTranslationIds,
      [translationId]: !expandedTranslationIds[translationId],
    });
  }

  return (
    <ContentSection title="App Translations" collapsable={false}>
      <CheckBoxLabelContainer
        onClick={() => setAppType(AppTranslationAppType.ConsumerApp)}
      >
        <Checkbox checked={appType === AppTranslationAppType.ConsumerApp} />
        <CheckBoxLabel>Consumer App</CheckBoxLabel>
      </CheckBoxLabelContainer>
      <CheckBoxLabelContainer
        onClick={() => setAppType(AppTranslationAppType.PartnerApp)}
      >
        <Checkbox checked={appType === AppTranslationAppType.PartnerApp} />
        <CheckBoxLabel>Partner App</CheckBoxLabel>
      </CheckBoxLabelContainer>

      <br />

      {loading && <div>Loading...</div>}
      {!loading && data && (
        <Table>
          <thead>
            <tr>
              <th>Translation name</th>
              <th>Translations</th>
              <th>Updated at</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.getAppTranslations.map((translation) => {
              return (
                <>
                  <tr key={translation.id}>
                    <td>{translation.name}</td>
                    <td>
                      <a href={translation.url} target="_blank">
                        Download
                      </a>
                    </td>
                    <td>{translation.updated_at}</td>
                    <td>
                      <Button
                        size="sm"
                        color="danger"
                        onClick={() => onRemoveAppTranslationClick(translation)}
                      >
                        Delete
                      </Button>
                    </td>
                    <td>
                      <Button
                        size="sm"
                        onClick={() =>
                          toggleExpandTranslationId(translation.id)
                        }
                      >
                        {expandedTranslationIds[translation.id] ? (
                          <FaAngleDown />
                        ) : (
                          <FaAngleUp />
                        )}
                      </Button>
                    </td>
                  </tr>
                  {expandedTranslationIds[translation.id] && (
                    <tr>
                      <td colSpan={5}>
                        <EditAppTranslationForm translation={translation} />
                      </td>
                    </tr>
                  )}
                </>
              );
            })}
          </tbody>
        </Table>
      )}
      <br />
      <br />
      <CreateAppTranslation appType={appType} />
    </ContentSection>
  );
}
